document.addEventListener('option-value:changed', () => {
  buildSubscriptionWidget();
});

buildSubscriptionWidget();

function buildSubscriptionWidget() {
  const flowOptions = document.querySelectorAll('.subscription-flow__options .subscription-flow__option');
  const flowTriggers = document.querySelectorAll('.subscription-flow__trigger');
  const flowCloses = document.querySelectorAll('.subscription-drawer-close');
  const flowSummarys = document.querySelectorAll('.subscription-flow__open-wrapper');
  const flowSubmits = document.querySelectorAll('.subscription-flow__submit');
  const flowPrices = document.querySelectorAll('.subscription-flow__price');
  const flowPricesCompare = document.querySelectorAll('.subscription-flow__price-compare');
  const sellingPlanInputs = document.querySelectorAll('input.selected-selling-plan-id');
  const quantityInputs = document.querySelectorAll('input.selected-quantity');
  const variantIdInputs = document.querySelectorAll('input.product-variant-id');
  const uniqueIdentifiers = document.querySelectorAll('input.unique-identifier');
  const quanity3xbags = document.querySelectorAll('.subscription-flow__option-button[data-quantity="3"]');
  const quanity2xbags = document.querySelectorAll('.subscription-flow__option-button[data-quantity="2"]');
  const productVariantsJSON = document.querySelector('[data-product-variants]:not(.gift-variants)');
  const productGiftVariantsJSON = document.querySelector('.gift-variants[data-product-variants]');
  const subscriptionsDiscountsJSON = document.querySelector('[data-subscription-discounts]');
  const productVariants = productVariantsJSON ? JSON.parse(productVariantsJSON.innerHTML) : null;
  const productGiftVariants = productGiftVariantsJSON ? JSON.parse(productGiftVariantsJSON.innerHTML) : null;
  const subscriptionDiscounts = subscriptionsDiscountsJSON ? JSON.parse(subscriptionsDiscountsJSON.innerHTML) : null;
  const initialPrice = document.querySelector('.subscription-flow__option-button.selected').dataset.price;
  const initialQuantity = document.querySelector('.subscription-flow__option-button.selected').dataset.quantity;
  const initialDiscount = document.querySelector('.subscription-flow__option-button.selected').dataset.discount;
  const initialVariantId = document.querySelector('.subscription-flow__option-button.selected').dataset.variantId;
  const initialType = document.querySelector('.subscription-flow__option-button.selected').dataset.type;
  const errorMessages = document.querySelectorAll('.subscription-flow__error-message');
  const isGift = document.querySelector('.subscription-gift') != null;

  const recFirstName = document.querySelector('input#gift_recipient_first_name');
  const recLastName = document.querySelector('input#gift_recipient_last_name');
  const recEmail = document.querySelector('input#gift_recipient_email');
  const giftMessage = document.querySelector('textarea#gift_message');
  const senderName = document.querySelector('input#gift_sender_name');
  const giftSchedule = document.querySelector('input#gift_notification_scheduled_at');

  const checkCartData = async () => {
    let cartContents;
    const fetchCart = async () => {
      const response = await fetch(window.Shopify.routes.root + 'cart.js');
      const data = await response.json();
      cartContents = data;
    };

    await fetchCart();

    if (cartContents) {
      const cartItems = cartContents.items;
      const hasSubscriptionItem = cartItems.some(
        (item) => item.properties && item.properties._lineitem_identifier != ''
      );
      if (hasSubscriptionItem) {
        disableSubmitButtons();
        errorMessages.forEach((errorMessage) => {
          errorMessage.classList.remove('hidden');
          errorMessage.textContent = window.subscriptionStrings.max_quantity_error;
          errorMessage.setAttribute('aria-hidden', 'false');
          errorMessage.setAttribute('role', 'alert');
        });
      } else {
        enableSubmitButtons();
        errorMessages.forEach((errorMessage) => {
          errorMessage.classList.add('hidden');
          errorMessage.textContent = '';
          errorMessage.setAttribute('aria-hidden', 'true');
          errorMessage.removeAttribute('role');
        });
      }
    } else {
      disableSubmitButtons();
      errorMessages.forEach((errorMessage) => {
        errorMessage.classList.remove('hidden');
        errorMessage.textContent = window.subscriptionStrings.generic_error;
        errorMessage.setAttribute('aria-hidden', 'false');
        errorMessage.setAttribute('role', 'alert');
      });
    }
  };

  if (!isGift) {
    checkCartData();
  }

  if (!isGift) {
    subscribe(PUB_SUB_EVENTS.cartUpdate, () => {
      checkCartData();
    });
  }

  const disableSubmitButtons = () => {
    flowSubmits.forEach((flowSubmit) => {
      flowSubmit.classList.add('disabled');
      flowSubmit.setAttribute('disabled', 'true');
    });
  };

  const enableSubmitButtons = () => {
    flowSubmits.forEach((flowSubmit) => {
      flowSubmit.classList.remove('disabled');
      flowSubmit.removeAttribute('disabled');
    });
  };

  const updatePrice = (price, quantity, discount) => {
    flowPrices.forEach((priceElement) => {
      priceElement.textContent = Math.round((price * quantity) / 100) + ' DKK';
      if (discount && discount != '0' && discount != '') {
        priceElement.classList.add('hidden');
      } else {
        priceElement.classList.remove('hidden');
      }
    });
  };

  const updateComparePrice = (price, quantity, discount) => {
    if (discount && discount != '0' && discount != '') {
      flowPricesCompare.forEach((priceElement) => {
        priceElement.classList.remove('hidden');
        priceElement.textContent = Math.round((price * quantity - discount * 100) / 100) + ' DKK';
      });
    } else {
      flowPricesCompare.forEach((priceElement) => {
        priceElement.classList.add('hidden');
        priceElement.textContent = '';
      });
    }
  };

  const setDiscounts = (variantId) => {
    subscriptionDiscounts.forEach((discount) => {
      //check if button.dataset.variantId is included in the discount.variantIds
      if (discount.variantIds.includes(variantId)) {
        const discountElements = document.querySelectorAll(
          `.subscription-flow__option-button[data-quantity="${discount.quantity}"]`
        );
        discountElements.forEach((element) => {
          element.dataset.discount = discount.amount;
        });
      }
    });
  };

  updatePrice(initialPrice, isGift ? 1 : initialQuantity, initialDiscount);
  updateComparePrice(initialPrice, isGift ? 1 : initialQuantity, initialDiscount);
  setDiscounts(initialVariantId);

  const resetForm = () => {
    quantityInputs.forEach((input) => (input.value = isGift ? '1' : initialQuantity));
    sellingPlanInputs.forEach((input) => (input.value = ''));
    uniqueIdentifiers.forEach((input) => (input.value = ''));
  };

  const setType = (type) => {
    if (type === undefined || productGiftVariants === null) return;
    productGiftVariants?.forEach((variant) => {
      if (variant.type === type) {
        const numberOfBags = variant.bags;
        const bagButtons = document.querySelectorAll('.subscription-flow__option-button[data-bags]');
        bagButtons.forEach((button) => {
          if (button.dataset.bags === numberOfBags) {
            button.dataset.productId = variant.product_id;
          }
          // Add disbaled class to bag button is no variant exists for that bag count
          const matchingVariants = productGiftVariants.filter(
            (variant) => variant.bags == button.dataset.bags && variant.type === type
          );
          if (matchingVariants.length === 0) {
            button.classList.add('disabled');
            button.setAttribute('aria-disabled', 'true');
            button.dataset.productId = '';
            // If the currently selected button is disabled, select the first available option
            if (button.classList.contains('selected')) {
              const firstAvailableButton = Array.from(bagButtons).find((btn) => !btn.classList.contains('disabled'));
              if (firstAvailableButton) {
                firstAvailableButton.classList.add('selected');
                button.classList.remove('selected');
                setType(firstAvailableButton.dataset.type);
              }
            }
          } else {
            button.classList.remove('disabled');
            button.removeAttribute('aria-disabled');
          }
        });
      }
    });
    const selectedBagsButton = document.querySelector('.subscription-flow__option-button[data-product-id].selected');
    if (selectedBagsButton) {
      setBags(selectedBagsButton.dataset.productId);
    }
  };

  const setBags = (productID) => {
    const selectedBagsButton = document.querySelector('.subscription-flow__option-button[data-product-id].selected');
    if (selectedBagsButton) {
      const selectedProductVariants = productGiftVariants?.filter(
        (variant) => variant.product_id == productID ?? selectedBagsButton.dataset.productId
      );
      const shipmentButtons = document.querySelectorAll('.subscription-flow__option-button[data-shipments]');
      shipmentButtons.forEach((shipmentButton) => {
        if (selectedProductVariants) {
          selectedProductVariants.forEach((variant) => {
            if (variant.shipments === shipmentButton.dataset.shipments) {
              shipmentButton.dataset.variantId = variant.id;
              shipmentButton.dataset.price = variant.price;
            }
          });
        }
      });
    }
    const selectedVariantButtonId = document.querySelector(
      '.subscription-flow__option-button[data-variant-id].selected'
    ).dataset.variantId;
    variantIdInputs.forEach((input) => (input.value = selectedVariantButtonId));
  };

  if (isGift) {
    setType(initialType);
  }

  const handleOptionClick = (button, optionButtons) => {
    const buttonId = button.dataset.buttonId;
    optionButtons.forEach((btn) => {
      if (btn.dataset.buttonId === buttonId) {
        btn.classList.add('selected');
      } else {
        btn.classList.remove('selected');
      }
    });
    if (button.dataset.variantId && subscriptionDiscounts) {
      setDiscounts(button.dataset.variantId);
    }
    if (isGift && button.dataset.type) {
      setType(button.dataset.type);
    }
    if (!isGift && button.dataset.quantity) {
      quantityInputs.forEach((input) => (input.value = button.dataset.quantity));
    }
    if (button.dataset.sellingPlanId) {
      sellingPlanInputs.forEach((input) => (input.value = button.dataset.sellingPlanId));
    }
    if (isGift && button.dataset.productId) {
      setBags(button.dataset.productId);
    }
    if (button.dataset.variantId) {
      let selectedVariant;
      if (productGiftVariants && button.closest('.subscription-flow').classList.contains('subscription-type__gift')) {
        const productId = document.querySelector('.subscription-flow__option-button[data-product-id].selected')?.dataset
          .productId;
        selectedVariant = productGiftVariants?.find(
          (variant) => variant.id == button.dataset.variantId && variant.product_id == productId
        );
      } else {
        selectedVariant = productVariants?.find((variant) => variant.id == button.dataset.variantId);
      }
      if (!selectedVariant) {
        selectedVariant = productVariants?.find((product) => {
          return product.variants.find((variant) => variant.id == button.dataset.variantId);
        })?.variants[0];
      }

      const sellingPlans = isGift ? [] : selectedVariant.selling_plan_allocations;
      const frequencyButtons = [
        ...document.querySelectorAll('.subscription-flow__option-button[data-selling-plan-id]'),
      ];
      const sellingPlansMappingArray = [...sellingPlans, ...sellingPlans]; // Duplicate array to map to frequency buttons (one for mobile and one for desktop)

      for (i = 0; i < frequencyButtons.length; i++) {
        frequencyButtons[i].dataset.sellingPlanId = sellingPlansMappingArray[i]?.selling_plan_id;
        frequencyButtons[i].dataset.sellingPlanPrice = sellingPlansMappingArray[i]?.price;
      }

      const selectedFrequencyButton = frequencyButtons.find((button) => button.classList.contains('selected'));
      sellingPlanInputs.forEach((input) => (input.value = selectedFrequencyButton.dataset.sellingPlanId));

      variantIdInputs.forEach((input) => (input.value = button.dataset.variantId));
      if (button.dataset.buttonId === 'variant-Mixed') {
        quanity3xbags.forEach((button) => {
          if (button.classList.contains('selected')) {
            quanity2xbags.forEach((button) => {
              button.classList.add('selected');
            });
            quantityInputs.forEach((input) => (input.value = '2'));
          }
          button.classList.remove('selected');
          button.classList.add('disabled');
          button.setAttribute('aria-disabled', 'true');
        });
      } else {
        quanity3xbags.forEach((button) => {
          button.classList.remove('disabled');
          button.removeAttribute('aria-disabled');
        });
      }
    }

    const quantity =
      button.dataset.quantity ||
      (button.closest('.subscription-flow__options').classList.contains('desktop')
        ? document.querySelector(
            '.subscription-flow__options.desktop .subscription-flow__option-button[data-quantity].selected'
          )?.dataset.quantity
        : document.querySelector(
            '.subscription-flow__options.mobile .subscription-flow__option-button[data-quantity].selected'
          )?.dataset.quantity);

    const price =
      button.dataset.sellingPlanPrice ||
      button.dataset.price ||
      (button.closest('.subscription-flow__options').classList.contains('desktop')
        ? button.closest('.subscription-flow').classList.contains('subscription-type__gift')
          ? document.querySelector(
              '.subscription-flow__options.desktop .subscription-flow__option-button[data-price].selected'
            ).dataset.price
          : document.querySelector(
              '.subscription-flow__options.desktop .subscription-flow__option-button[data-selling-plan-price].selected'
            )?.dataset.sellingPlanPrice
        : button.closest('.subscription-flow').classList.contains('subscription-type__gift')
        ? document.querySelector(
            '.subscription-flow__options.mobile .subscription-flow__option-button[data-price].selected'
          ).dataset.price
        : document.querySelector(
            '.subscription-flow__options.mobile .subscription-flow__option-button[data-selling-plan-price].selected'
          )?.dataset.sellingPlanPrice);

    const discount =
      (button.closest('.subscription-flow__options').classList.contains('desktop')
        ? document.querySelector(
            '.subscription-flow__options.desktop .subscription-flow__option-button[data-discount].selected'
          ).dataset.discount
        : document.querySelector(
            '.subscription-flow__options.mobile .subscription-flow__option-button[data-discount].selected'
          ).dataset.discount) || 0;

    updatePrice(price, isGift ? 1 : quantity, discount);
    updateComparePrice(price, isGift ? 1 : quantity, discount);
  };

  flowOptions.forEach((option) => {
    const optionButtons = option.querySelectorAll('.subscription-flow__option-button');
    optionButtons.forEach((button) => button.addEventListener('click', () => handleOptionClick(button, optionButtons)));
  });

  flowTriggers.forEach((trigger) => {
    trigger.addEventListener('click', () => {
      const optionsClass = trigger
        .closest('.subscription-flow__disclosure')
        .querySelector('.subscription-flow__options')
        .classList.contains('desktop')
        ? 'desktop'
        : 'mobile';
      const selectedQuantity = trigger.classList.contains('subscription-gift')
        ? 3
        : document.querySelector(
            `.subscription-flow__options.${optionsClass} .subscription-flow__option-button[data-quantity].selected`
          )?.dataset.quantity;
      const selectedPlan = trigger.classList.contains('subscription-gift')
        ? null
        : document.querySelector('.subscription-flow__option-button[data-selling-plan-id].selected');
      const price = trigger.classList.contains('subscription-gift')
        ? document.querySelector('.subscription-type__gift .subscription-flow__option-button[data-price].selected')
            .dataset.price
        : selectedPlan?.dataset.sellingPlanPrice;
      const discount = trigger.classList.contains('subscription-gift')
        ? document.querySelector('.subscription-type__gift .subscription-flow__option-button[data-discount].selected')
            .dataset.discount
        : document.querySelector('.subscription-flow__option-button[data-discount].selected').dataset.discount;
      const selectedVariant = trigger.classList.contains('subscription-gift')
        ? document.querySelector(
            `.subscription-type__gift .subscription-flow__options.${optionsClass} .subscription-flow__option-button[data-variant-id].selected`
          )
        : document.querySelector(
            `.subscription-flow__options.${optionsClass} .subscription-flow__option-button[data-variant-id].selected`
          );

      quantityInputs.forEach((input) => (input.value = selectedQuantity));
      sellingPlanInputs.forEach((input) => (input.value = selectedPlan?.dataset.sellingPlanId ?? ''));
      variantIdInputs.forEach((input) => (input.value = selectedVariant?.dataset.variantId));
      uniqueIdentifiers.forEach((input) => (input.value = Math.floor(Math.random() * 9000000000) + 1000000000));

      updatePrice(price, isGift ? 1 : selectedQuantity, discount);
      updateComparePrice(price, isGift ? 1 : selectedQuantity, discount);
    });
  });

  flowCloses.forEach((close) => close.addEventListener('click', resetForm));

  flowSummarys.forEach((summary) => {
    summary.addEventListener('click', () => {
      if (summary.parentElement.hasAttribute('open')) {
        resetForm();
      }
    });
  });

  if (flowSubmits) {
    flowSubmits.forEach((flowSubmit) => {
      flowSubmit.addEventListener('click', (event) => {
        event.preventDefault();
        submitForm(event);
      });
      if (flowSubmit.classList.contains('gift-trigger')) {
        const checkGiftInputs = () => {
          if (recFirstName.value && recLastName.value && recEmail.value && senderName.value && giftSchedule.value) {
            flowSubmit.classList.remove('disabled');
            flowSubmit.removeAttribute('disabled');
          } else {
            flowSubmit.classList.add('disabled');
            flowSubmit.setAttribute('disabled', 'true');
          }
        };

        [recFirstName, recLastName, recEmail, senderName, giftSchedule].forEach((input) => {
          input.addEventListener('input', checkGiftInputs);
        });

        checkGiftInputs(); // Initial check
      }
    });
  }

  function submitForm(event) {
    const form = event.target.closest('.subscription-flow__form') || document.querySelector('product-form form');
    const cart = document.querySelector('cart-drawer');
    const selectedVariantName = document.querySelector('.subscription-flow__option-button.selected[data-variant-id]')
      .dataset.buttonId;
    const isMixed = selectedVariantName === 'variant-Mixed';

    const config = fetchConfig('javascript');
    config.headers['X-Requested-With'] = 'XMLHttpRequest';
    delete config.headers['Content-Type'];

    const formData = new FormData(form);

    if (isGift) {
      formData.set('quantity', '1');
    } else if (
      !(formData.get('quantity') === '2' || formData.get('quantity') === '3' || formData.get('quantity') === '4') ||
      (isMixed && formData.get('quantity') === '3')
    ) {
      formData.set('quantity', '2');
    }

    // if the gift consts above are non-null, append them to the form data
    if (recFirstName) formData.append(recFirstName.name, recFirstName.value);
    if (recLastName) formData.append(recLastName.name, recLastName.value);
    if (recEmail) formData.append(recEmail.name, recEmail.value);
    if (giftMessage) formData.append(giftMessage.name, giftMessage.value);
    if (senderName) formData.append(senderName.name, senderName.value);
    if (giftSchedule) formData.append(giftSchedule.name, giftSchedule.value);

    if (cart) {
      formData.append(
        'sections',
        cart.getSectionsToRender().map((section) => section.id)
      );
      formData.append('sections_url', window.location.pathname);
      cart.setActiveElement(document.activeElement);
    }
    config.body = formData;

    fetch(`${routes.cart_add_url}`, config)
      .then((response) => response.json())
      .then((response) => {
        if (response.status) {
          publish(PUB_SUB_EVENTS.cartError, {
            source: 'product-form',
            productVariantId: formData.get('id'),
            errors: response.errors || response.description,
            message: response.message,
          });
        } else if (!cart) {
          window.location = window.routes.cart_url;
          return;
        }
        publish(PUB_SUB_EVENTS.cartUpdate, {
          source: 'product-form',
          productVariantId: formData.get('id'),
          cartData: response,
          message: 'Add to cart',
        });
        cart.renderContents(response);
      })
      .catch((e) => {
        console.error(e);
      })
      .finally(() => {
        if (cart && cart.classList.contains('is-empty')) cart.classList.remove('is-empty');
        resetForm();
      });
  }
}
